<template>
  <div>
    <div
      style="position: absolute;top: 50%; left: 52%; width: 10%; z-index: 2;"
      v-show="loadData == true"
    >
      <md-progress-spinner
        :md-stroke="8"
        :md-diameter="65"
        md-mode="indeterminate"
      ></md-progress-spinner>
    </div>

    <div :class="showDialogConfirm ? 'bg-backdrop-set-config' : ''"></div>

    <md-dialog
      :md-active.sync="value"
      class="mkt-ops -main-font set-config-promotion"
      :md-click-outside-to-close="false"
    >
      <md-dialog-title>Change of person in charge "Promotion"</md-dialog-title>

      <div class="dialog-content">
        <div class="search-user">
          <div class="account-code" style="margin-right: 40px;">
            <label style="margin-left: 10px; font-weight: 400;"
              >User account code</label
            >
            <multiselect
              v-model="selectedUserAccountCode"
              label="firstname"
              track-by="code"
              placeholder="User account code"
              :open-direction="'bottom'"
              :options="dpUserAccount"
              :searchable="true"
              :max-height="180"
              :show-no-results="false"
              :custom-label="customLabelUserAccount"
              :select-label="''"
              :deselect-label="''"
              :selected-label="''"
              :hide-selected="true"
              @select="setDataUserAccountCode"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                <div>
                  <div
                    class="-label"
                    style="font-family: kanit; padding-top: 3px;"
                  >
                    {{ option.firstname }} {{ option.lastname }}
                  </div>
                  <div
                    class="-delete"
                    style="padding-top: 2px; margin-right: 8px;"
                    @mousedown.prevent.stop="clearUserAccountCode(option.code)"
                  >
                    <i class="material-icons">close</i>
                  </div>
                </div>
              </template>
            </multiselect>
          </div>

          <div style="display: grid;" v-show="isEdit">
            <label style="padding-top: 7px; font-weight: bold; color: #3f51b5;"
              >Move to</label
            >
            <md-icon style="padding-bottom: 5px;">
              <span style="font-size: 32px; color: #3f51b5;"
                >arrow_right_alt</span
              >
            </md-icon>
          </div>

          <div
            class="account-change"
            style="margin-left: 40px;"
            v-show="isEdit"
          >
            <label style="margin-left: 10px; font-weight: 400;"
              >User account change new</label
            >
            <multiselect
              v-model="selectedUserAccountChange"
              label="firstname"
              track-by="code"
              placeholder="User account change new"
              :open-direction="'bottom'"
              :options="dpUserAccount"
              :searchable="true"
              :max-height="180"
              :show-no-results="false"
              :custom-label="customLabelUserAccount"
              :select-label="''"
              :deselect-label="''"
              :selected-label="''"
              :hide-selected="true"
              @select="setDataUserAccountChange"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                <div>
                  <div
                    class="-label"
                    style="font-family: kanit; padding-top: 3px;"
                  >
                    {{ option.firstname }} {{ option.lastname }}
                  </div>
                  <div
                    class="-delete"
                    style="padding-top: 2px; margin-right: 8px;"
                    @mousedown.prevent.stop="
                      clearUserAccountChange(option.code)
                    "
                  >
                    <i class="material-icons">close</i>
                  </div>
                </div>
              </template>
            </multiselect>
          </div>
        </div>

        <!-- TABLE -->
        <div id="table-promotion">
          <div id="divHeadList">
            <div style="width: 5%;" v-show="isEdit">
              <label class="-mkt-checkbox-container">
                <input
                  type="checkbox"
                  @click="selectAllProductFilter"
                  v-model="checkedProductFilterAll"
                />
                <span class="-mkt-checkbox"></span>
              </label>
            </div>
            <div style="width: 18%;">Code</div>
            <div :style="isEdit ? 'width: 27.5%' : 'width: 32.5%'">Title</div>
            <div style="width: 8%">Status</div>
            <div style="width: 14%">Create By</div>
            <div style="width: 14%">Old User</div>
            <div style="width: 13.5%;">Create Date</div>
          </div>
          <div id="divBodyList">
            <div
              v-show="tablePromotion.length === 0"
              :class="'row-bg-gray'"
              style="display: block; text-align: center; font-size: 14px;"
            >
              No data in table.
            </div>
            <div
              :class="'row-bg-gray -pointer'"
              v-for="(item, rIndex) in tablePromotion"
              :key="rIndex"
            >
              <div style="width: 5%;" v-show="isEdit">
                <label class="-mkt-checkbox-container">
                  <input
                    type="checkbox"
                    v-model="checkedProductFilter"
                    :id="item.promotion_id"
                    :value="item.promotion_id"
                    @click="selectProductFilter(item.promotion_id)"
                  />
                  <span class="-mkt-checkbox"></span>
                </label>
              </div>
              <div style="width: 18%;" class="nowrap-title -font-kanit">
                <span
                  :title="item.promotion_code"
                  :style="isEdit ? '' : 'padding-left: 5px;'"
                >
                  {{ item.promotion_code }}
                </span>
              </div>
              <div
                :style="isEdit ? 'width: 27.5%' : 'width: 32.5%;'"
                class="nowrap-title -font-kanit"
              >
                <span :title="item.promotion_title">
                  {{ item.promotion_title }}
                </span>
              </div>
              <div style="width: 8%;" class="-font-kanit">
                {{ checkStatusPeriods(item) }}
              </div>
              <div style="width: 14%;" class="-font-kanit">
                {{ item.create_by[0].displayname }}
              </div>
              <div style="width: 14%;" class="-font-kanit">
                {{ item.old_displayname }}
              </div>
              <div style="width: 13.5%;">{{ formatDate(item.c_time) }}</div>
            </div>
          </div>
          <div class="footer-table">
            number of lines in page ({{ tablePromotion.length }})
          </div>
        </div>
      </div>

      <md-dialog-actions class="-action">
        <md-button class="md-primary -cancel" @click="onClickCancel()"
          >CANCEL</md-button
        >
        <md-button
          v-show="isEdit"
          class="md-primary -update"
          @click="onClickUpdate()"
          >UPDATE DATA</md-button
        >
      </md-dialog-actions>
    </md-dialog>

    <md-dialog-confirm
      class="dialog-confirm-set-config"
      :md-active.sync="confirmChange"
      :md-title="titleConfirm"
      :md-content="textConfirm"
      :md-confirm-text="textBtnConfirm"
      md-cancel-text="Cancel"
      @md-cancel="onCancel"
      @md-confirm="onConfirm"
    />

    <md-snackbar
      :md-position="position"
      :md-duration="isInfinity ? Infinity : duration"
      :md-active.sync="showSnackbar"
      md-persistent
    >
      <span>{{ dContent }}</span>
      <md-button class="md-primary" @click="showSnackbar = false">OK</md-button>
    </md-snackbar>
  </div>
</template>

<script>
import SettingService from "@/services/setting";
import moment from "moment-timezone";
import Vue from "vue";

export default {
  name: "set-config-promotion",
  props: ["value", "dpUserAccount"],
  components: {},
  created() {},
  watch: {},
  computed: {
    permit() {
      return this.$jwt.decode(localStorage.getItem("token"));
    },
    isEdit() {
      return this.permit.acl["setting"].menus["set-config"].edit;
    }
  },
  data() {
    return {
      loadData: false,
      selectedUserAccountCode: [],
      // optionsUserAccountCode: [],
      selectedUserAccountChange: [],
      // optionsUserAccountChange: [],
      userCode: "",
      userChange: "",
      tablePromotion: [],
      checkedProductFilter: [],
      checkedProductFilterAll: false,
      confirmChange: false,
      titleConfirm: "Confirm ?",
      textConfirm: "",
      textBtnConfirm: "",
      checkConfirm: "",
      showDialogConfirm: false,
      showSnackbar: false,
      dContent: "",
      position: "center",
      duration: 20000,
      isInfinity: false
    };
  },
  mounted() {},
  methods: {
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    checkStatusPeriods(item) {
      var now = moment();
      var startdate = moment(new Date(item.startdate));
      var enddate = moment(new Date(item.enddate));
      if (startdate <= now && enddate >= now) {
        return "Present";
      } else if (startdate > now) {
        return "Future";
      } else if (enddate < now) {
        return "Old";
      }
    },
    selectAllProductFilter() {
      this.checkedProductFilter = [];
      if (!this.checkedProductFilterAll) {
        for (let i in this.tablePromotion) {
          this.checkedProductFilter.push(this.tablePromotion[i].promotion_id);
        }
      }
    },
    selectProductFilter(id) {
      if (this.checkedProductFilter.indexOf(id) == -1) {
        this.checkedProductFilter.push(id);
      } else {
        this.checkedProductFilter.splice(
          this.checkedProductFilter.indexOf(id),
          1
        );
      }
    },
    onClickCancel() {
      if (!this.isEdit) {
        this.selectedUserAccountCode = [];
        this.selectedUserAccountChange = [];
        this.tablePromotion = [];
        this.checkedProductFilter = [];
        this.checkedProductFilterAll = false;
        this.userCode = "";
        this.userChange = "";
        this.$emit("clickCancel");
      } else {
        this.titleConfirm = "";
        this.textConfirm = "Are you sure you want to cancel changes ?";
        this.textBtnConfirm = "OK";
        this.confirmChange = true;
        this.checkConfirm = "cancel";
        this.showDialogConfirm = true;

        // this.selectedUserAccountCode = [];
        // this.selectedUserAccountChange = [];
        // this.tablePromotion = [];
        // this.checkedProductFilter = [];
        // this.checkedProductFilterAll = false;

        // this.$emit("clickCancel");
      }
    },
    onClickUpdate() {
      if (this.userCode === "") {
        this.dContent = "Please select User account code";
        this.showSnackbar = true;
        return false;
      } else if (this.userChange === "") {
        this.dContent = "Please select User account change new";
        this.showSnackbar = true;
        return false;
      } else if (this.checkedProductFilter.length === 0) {
        this.dContent = "Please select data for update.";
        this.showSnackbar = true;
        return false;
      } else {
        this.titleConfirm = "Confirm ?";
        this.textConfirm = "Are you sure you want to update ?";
        this.textBtnConfirm = "sure";
        this.confirmChange = true;
        this.checkConfirm = "update";
        this.showDialogConfirm = true;
      }

      // let user = Vue.$jwt.decode(localStorage.getItem("token"));
      // let chaeckall =
      //   this.checkedProductFilter.length === this.tablePromotion.length
      //     ? true
      //     : false;
      // let dataSave = {
      //   user: this.userCode,
      //   new_user: this.userChange,
      //   update_by: user.code,
      //   all: chaeckall,
      //   select: chaeckall ? [] : this.checkedProductFilter
      // };
      // // console.log("dataSave ==>", dataSave);

      // this.loadData = true;
      // SettingService.updateConfigChangeCreateby("promotion", dataSave).then(
      //   response => {
      //     // console.log("response ==>", response);
      //     this.loadData = false;

      //     this.selectedUserAccountCode = [];
      //     this.selectedUserAccountChange = [];
      //     this.tablePromotion = [];
      //     this.checkedProductFilter = [];
      //     this.checkedProductFilterAll = false;

      //     this.$emit("clickUpdate");
      //   }
      // );
    },
    customLabelUserAccount({ firstname, lastname }) {
      return `${firstname} ${lastname}`;
    },
    setDataUserAccountCode(selectedOption) {
      this.userCode = selectedOption.code;
      this.loadData = true;

      let datas = { menu: "promotion", code: selectedOption.code };
      SettingService.getConfigListPromotionVD(datas).then(response => {
        if (response && response.data.length > 0) {
          this.tablePromotion = response.data;
        } else {
          this.tablePromotion = [];
        }
        this.loadData = false;
      });
    },
    setDataUserAccountChange(selectedOption) {
      this.userChange = selectedOption.code;
    },
    clearUserAccountCode(code, type) {
      this.selectedUserAccountCode = [];
      this.tablePromotion = [];
      this.userCode = "";
    },
    clearUserAccountChange(code, type) {
      this.selectedUserAccountChange = [];
      this.userChange = "";
    },
    onCancel() {
      this.showDialogConfirm = false;
    },
    onConfirm() {
      if (this.checkConfirm === "cancel") {
        this.selectedUserAccountCode = [];
        this.selectedUserAccountChange = [];
        this.tablePromotion = [];
        this.checkedProductFilter = [];
        this.checkedProductFilterAll = false;
        this.userCode = "";
        this.userChange = "";
        this.$emit("clickCancel");
      } else if (this.checkConfirm === "update") {
        this.loadData = true;

        let user = Vue.$jwt.decode(localStorage.getItem("token"));
        let chaeckall =
          this.checkedProductFilter.length === this.tablePromotion.length
            ? true
            : false;
        let dataSave = {
          user: this.userCode,
          new_user: this.userChange,
          update_by: user.code,
          all: chaeckall,
          select: chaeckall ? [] : this.checkedProductFilter
        };
        // console.log("dataSave ==>", dataSave);

        SettingService.updateConfigChangeCreateby("promotion", dataSave).then(
          response => {
            // console.log("response ==>", response);
            this.loadData = false;

            this.selectedUserAccountCode = [];
            this.selectedUserAccountChange = [];
            this.tablePromotion = [];
            this.checkedProductFilter = [];
            this.checkedProductFilterAll = false;
            this.userCode = "";
            this.userChange = "";

            this.$emit("clickUpdate");
          }
        );
      }
      this.showDialogConfirm = false;
    }
  },
  beforeDestroy() {}
};
</script>

<style lang="scss">
.set-config-promotion,
.set-config-vd {
  z-index: 6;
  width: 85%;
  max-width: 85% !important;
  height: 80%;
  max-height: 80% !important;
  transform: unset !important;
  top: 9% !important;
  left: 7.5% !important;

  .md-dialog-title {
    font-size: 18px;
    margin-bottom: 5px;
    padding: 30px 30px 0;
    font-weight: bold;
  }

  .dialog-content {
    padding: 20px 30px;

    .search-user {
      display: flex;
      width: 100%;

      .account-code,
      .account-change {
        width: 25%;

        .multiselect {
          font-weight: 300;

          .z-index-top {
            z-index: 10;
          }

          margin: 5px 0px;

          .multiselect__single,
          .multiselect__input {
            font-size: 14px;

            div {
              display: flex;
              width: 100%;

              .-delete {
                width: 5%;
                margin: 0px 5px;

                .material-icons {
                  font-size: 18px;
                  margin-top: 1px;
                  cursor: pointer;
                  color: gray;
                }
              }
            }
          }

          .multiselect__tags {
            padding: 8px 30px 0 8px;

            input {
              font-family: lato;
              font-weight: 300;
            }

            .multiselect__placeholder {
              margin: 0px;
            }

            ::placeholder {
              color: #bdbdbd;
              opacity: 1;
            }
          }

          .multiselect__content-wrapper {
            font-size: 14px;
            z-index: 10;
            font-family: kanit;
          }

          .multiselect__option {
            min-height: 34px;
            padding: 12px 12px 0px 12px;
          }

          ::-webkit-scrollbar {
            width: 8px;
            height: 8px;
          }
        }
      }
    }

    #table-promotion,
    #table-volume-discount {
      .md-checkbox {
        display: flex;
        margin-top: 0px;
        margin-bottom: 0px;
        padding-left: 0px !important;
      }

      #divHeadList {
        width: 99.6%;
        display: -webkit-inline-box;
        font-size: 13px;
        font-weight: bold;
        margin-top: 15px;
        margin-bottom: 13px;

        div {
          // border: 1px solid pink;
          padding-left: 5px;
          padding-right: 5px;
          // color: #414141;

          &.-text-right {
            text-align: right;
          }

          &.-text-center {
            text-align: center;
          }
        }
      }

      #divBodyList {
        width: 100%;
        height: calc(80vmin - 255px);
        display: block;
        overflow-y: scroll;

        > div {
          width: 100%;
          height: 35px;
          display: -webkit-inline-box;
          padding-top: 5px;
          padding-bottom: 5px;

          div {
            // border: 1px solid pink;
            padding-left: 5px;
            padding-right: 5px;

            &.-text-right {
              text-align: right;
            }

            &.-text-center {
              text-align: center;
            }

            // &.nowrap-title {
            //   white-space: nowrap;
            //   overflow: hidden;
            //   text-overflow: ellipsis;
            // }
            &.nowrap-title {
              position: relative;
            }
            &.nowrap-title:before {
              content: "&nbsp;";
              visibility: hidden;
            }
            &.nowrap-title span {
              position: absolute;
              left: 0;
              right: 0;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }

        &::-webkit-scrollbar {
          height: 7px;
          width: 5px;
        }
      }

      .footer-table {
        // border: 1px solid pink;
        display: block;
        text-align: center;
        margin-top: 15px;
        width: 99.6%;
        font-size: 14px;
        font-style: italic;
      }
    }
  }

  .-action {
    position: fixed;
    padding: 8px 20px 10px 24px;
    bottom: 0px;
    margin-right: auto;
    margin-left: auto;
    width: 100%;
    justify-content: flex-end;

    .md-button {
      padding: 5px;
      margin: 5px;
    }

    .-cancel {
      color: #a8a8a8 !important;
      font-weight: bold;
      font-size: 16px;
    }

    .-update {
      color: #3f51b5;
      font-weight: bold;
      font-size: 16px;
      margin-left: 10px;
    }
  }
}

.dialog-confirm-set-config {
  z-index: 13 !important;
}

.bg-backdrop-set-config {
  background: rgba(0, 0, 0, 0.35);
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 12;
  top: 0;
  left: 0;
}
</style>
